let templateGuest = $('body').hasClass('layout-guest');

if (!templateGuest) {
    window.routeChangeSite = window.LaravelRoutes.changeSite;
    window.routeAdmin = window.LaravelRoutes.admin;
    window.routeFtpExcel = window.LaravelRoutes.ftpExcel;
}

import './bootstrap';

if (!(templateGuest)) {
    $("#siteSelect").select2();

    window.activeSiteID = $('select[name^="siteSelect"] option').filter(':selected').val();
    window.activeSiteName = $('select[name^="siteSelect"] option').filter(':selected').text();

    window.siteSelect = siteSelect;
}

function siteSelect(site) {
    let ajax_url = "{{ route('change-site') }}"

    let data = {
        siteID: site.value
    }

    $.ajax({
        url: ajax_url,
        type: 'POST',
        dataType: "json",
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        data: data,
        success: function (response) {
            if (response["result"] === true) {
                setTimeout(
                    function () {
                        window.location.href = "{{ route('admin')}}";
                    }, 0.5);
            }
        }
    });
}

window.loading = loading;

function loading(element, remove = false) {
    if (remove) {
        $(document).find(element).removeClass('loading');
    } else {
        $(document).find(element).addClass('loading');
    }
}





